<template lang="pug">
  #app
    router-view
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
*{
  padding:0;
  margin:0;
}
ul, ol{
  list-style-type: none;
}
</style>
